import React, { useState } from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import { useTranslation } from 'react-i18next';
import { handleDownloadProjectInputFile } from '../../../services/projectInputFileDownloadService';
import { useNavigate } from 'react-router-dom';

const ProjectDetails = ({
    projectCreationTime,
    id,
    name,
    theoreticalWeight,
    user,
    uploadedFileType,
    logLength,
    bindirmeOrani,
    floorAvailable,
    activated,
    unitPrice, 
    unitDiscount, 
    unitPriceType, 
    purchasable, 
    userType, 
    ownProject
 }) => {
    const { i18n, t } = useTranslation();

    const [dialogOpen, setDialogOpen] = useState(false)
    const [dialogContent, setDialogContent] = useState(<div></div>)

    let creationTime = new Date(projectCreationTime).toLocaleDateString(`${i18n.language}-${i18n.language.toUpperCase()}`);

    const pname = name === "Ornek-Proje" ? t("Ornek-Proje") : name
    const navigate = useNavigate();
    return (
        <>
            {dialogOpen &&
                <Dialog
                    maxWidth="xs"
                    fullWidth={true}
                    open={dialogOpen}
                    onClose={() => setDialogOpen(false)}>
                    <DialogContent>
                        {dialogContent}
                    </DialogContent>
                </Dialog>}
            <Container className='border border-top-0 p-3' fluid style={{ backgroundColor: 'white' }}>
                <h3 className="text-center d-block d-md-none">{t("Proje Bilgileri")}</h3>
                <Row>
                    <Col md={{ offset: 2, span: 8 }}>
                        <table className="table table-striped-columns border my-3 align-middle bg-white">
                            <tbody>
                                <tr>
                                    <th style={{ width: "45%" }}>{t("Proje Numarası")}&nbsp;
                                    </th>
                                    <td style={{ width: "65%" }}>{id}</td>
                                </tr>
                                <tr>
                                    <th>{t("Proje İsmi")}&nbsp;
                                    </th>
                                    <td>{pname}</td>
                                </tr>
                                <tr>
                                    <th>{t("Kullanıcı")}&nbsp;
                                    </th>
                                    <td>{user}</td>
                                </tr>
                                <tr>
                                    <th>{t("Oluşturma Zamanı")}&nbsp;
                                    </th>
                                    <td>{creationTime}</td>
                                </tr>
                                <tr>
                                    <th>{t("Proje Tipi")}&nbsp;
                                    </th>
                                    <td>{uploadedFileType}</td>
                                </tr>
                                <tr>
                                    <th>{t("Kesim Yapılan Demir Uzunluğu")}&nbsp;
                                    </th>
                                    <td>{logLength}</td>
                                </tr>
                                <tr>
                                    <th>{t("Bindirme Katsayısı")}&nbsp;
                                    </th>
                                    <td>{bindirmeOrani}</td>
                                </tr>
                                <tr>
                                    <th>{t("Toplam Teorik Ağırlık (kg)")}&nbsp;
                                    </th>
                                    <td>{theoreticalWeight}</td>
                                </tr>
                                <tr>
                                    <th>{t("Aktive Edildi mi?")}&nbsp;
                                    </th>
                                    <td>{activated ? t("Evet") : t("Hayır")}</td>
                                </tr>
                                <tr>
                                    <th>{t("Proje Dosyası")}&nbsp;
                                    </th>
                                    <td>
                                        <button
                                            className="btn btn-sm btn-outline-primary fw-bold"
                                            style={{ borderWidth: "2px" }}
                                            onClick={() => {
                                                handleDownloadProjectInputFile(id, t, navigate)
                                            }}
                                        >
                                            {t("İndir")}
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default ProjectDetails;
